import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAppConfig } from '../../context/AppConfigContext';
import ConfirmModal from '../common/ConfirmModal';
import {
  LayoutDashboard,
  Users,
  FolderOpen,
  MessageSquare,
  LogOut,
  User,
  Settings,
  Wallet,
  BookOpen
} from 'lucide-react';

function AdminLayout({ children, title, headerActions }) {
  const { user, logout } = useAuth();
  const { appName } = useAppConfig();
  const navigate = useNavigate();
  const location = useLocation();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  const handleLogout = () => {
    setLogoutModalOpen(true);
  };

  const confirmLogout = () => {
    setLogoutModalOpen(false);
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname === '/admin' && !location.pathname.startsWith('/admin/tutorial');
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="admin-page">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>
            <img src="/watson-logo.svg" alt={appName} className="sidebar-logo" />
            {appName}
          </h2>
        </div>

        {/* Navigation at top */}
        <nav className="admin-nav">
          <Link to="/admin" className={`admin-nav-item ${isActive('/admin') && !isActive('/admin/users') && !isActive('/admin/projects') && !isActive('/admin/config') && !isActive('/admin/costs') && !isActive('/admin/tutorial') ? 'active' : ''}`}>
            <LayoutDashboard size={20} />
            Dashboard
          </Link>
          <Link to="/admin/users" className={`admin-nav-item ${isActive('/admin/users') ? 'active' : ''}`}>
            <Users size={20} />
            Usuarios
          </Link>
          <Link to="/admin/projects" className={`admin-nav-item ${isActive('/admin/projects') ? 'active' : ''}`}>
            <FolderOpen size={20} />
            Proyectos
          </Link>
          <Link to="/admin/config" className={`admin-nav-item ${isActive('/admin/config') ? 'active' : ''}`}>
            <Settings size={20} />
            Configuraci&oacute;n
          </Link>
          <Link to="/admin/tutorial" className={`admin-nav-item ${isActive('/admin/tutorial') ? 'active' : ''}`}>
            <BookOpen size={20} />
            Tutorial
          </Link>
        </nav>

        <div className="admin-sidebar-spacer"></div>

        <div className="admin-sidebar-footer">
          <Link to="/admin/costs" className={`admin-nav-item ${isActive('/admin/costs') ? 'active' : ''}`}>
            <Wallet size={20} />
            Consumo
          </Link>
        </div>
      </aside>

      {/* Floating chat button */}
      <button className="floating-chat-btn" onClick={() => navigate('/chat')} title="Ir al Chat">
        <MessageSquare size={22} />
      </button>

      <main className="admin-content">
        <header className="admin-header">
          <div className="admin-header-left">
            {title}
          </div>
          <div className="admin-header-right">
            {headerActions}
            <div className="admin-user-info">
              <User size={18} />
              <span>{user?.username}</span>
              <span className="admin-badge">Admin</span>
            </div>
            <button className="logout-button" onClick={handleLogout} title="Cerrar sesión">
              <LogOut size={20} />
            </button>
          </div>
        </header>

        {children}
      </main>

      {/* Logout Confirmation Modal */}
      <ConfirmModal
        isOpen={logoutModalOpen}
        title="Cerrar Sesión"
        message="¿Estás seguro de que deseas cerrar sesión?"
        confirmText="Cerrar Sesión"
        onConfirm={confirmLogout}
        onCancel={() => setLogoutModalOpen(false)}
        danger={false}
      />
    </div>
  );
}

export default AdminLayout;
